// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 礼品介绍列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /gift/introduce/detail/list */
export async function giftIntroduceDetailListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftIntroduceDetailListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListRsGiftIntroduce>('/gift/introduce/detail/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 介绍图片 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /gift/introduce/picture */
export async function giftIntroducePictureUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.giftIntroducePictureUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/gift/introduce/picture', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
